'use strict';

var isDefined = require('./is-defined.js');
var isNull = require('./is-null.js');
var propTypes = require('./prop-types.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Check if a value is defined and not null.
 *
 * @function
 * @param {*} value - Value to be checked.
 * @returns {boolean} - Returns true or false.
 * @example
 * isDefinedAndNotNull(42);
 * // => true
 * isDefinedAndNotNull(NaN);
 * // => true
 */

var isDefinedAndNotNull = function isDefinedAndNotNull(value) {
  return isDefined(value) && !isNull(value);
};

isDefinedAndNotNull.HELPER_ID = 'Gearz.JsUtils.isDefinedAndNotNull';
isDefinedAndNotNull.returnType = propTypes.boolWithDescription('Returns true in case of value is defined and not null, false otherwise.');
isDefinedAndNotNull.parameterTypes = {
  value: propTypes.anyWithDescription('Value to be checked.')
};
isDefinedAndNotNull.defaultParameters = {
  value: undefined
};

module.exports = isDefinedAndNotNull;
